exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".w-imbee-footer[data-v-2ab464f7],.w-imbee-footer a[data-v-2ab464f7]{transition:color .3s ease}.w-imbee-footer[data-v-2ab464f7]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:999;text-align:center;font-size:12px;padding:8px 4px;box-shadow:0 -3px 8px -1px hsla(0,0%,47%,.12);background-color:#fff;border-radius:0 0 12px 12px;color:hsla(0,0%,47%,.6)}.w-imbee-footer a[data-v-2ab464f7]{font-weight:700;text-decoration:none;cursor:pointer;color:rgba(92,92,92,.7)}.w-imbee-footer a[data-v-2ab464f7]:hover{color:#505050}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2ab464f7","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 176
// module chunks = 0 1